// src/components/meeting/panels/EditPanel.jsx
import { useMemo } from "react";
import MeetingForm from "../MeetingForm";

function normalizeStr(s) {
  return String(s ?? "")
    .trim()
    .replace(/\s+/g, " ");
}
function buildCompositeKey(title, iso, location) {
  return `${normalizeStr(title)}|${iso}|${normalizeStr(location)}`;
}

export default function EditPanel({
  item,
  projectId,
  existingCompositeKeySet,
  onSaved,
  onClose,
}) {
  const originalCompositeKey = useMemo(() => {
    if (!item?.schedule) return null;
    try {
      const iso = new Date(item.schedule).toISOString();
      return buildCompositeKey(item.title, iso, item.location);
    } catch {
      return null;
    }
  }, [item]);

  return (
    <MeetingForm
      mode="update"
      projectId={projectId}
      initialDate={new Date(item.schedule)}
      initial={item}
      existingCompositeKeySet={existingCompositeKeySet}
      originalCompositeKey={originalCompositeKey}
      onCancel={onClose}
      onSaved={onSaved}
    />
  );
}
